import PrintSharpIcon from "@mui/icons-material/PrintSharp";
import { Skeleton, Stack, Typography, useTheme } from "@mui/material";
import Highlight from "components/ui/atoms/Highlight";
import PVSignatures from "components/ui/atoms/PVSignatures";
import Layout from "components/ui/molecules/Layout";
import {
  TopRightMenu,
  TopRightMenuItem,
} from "components/ui/molecules/TopRightMenu";
import dayjs from "dayjs";
import CommitteeMinutePrintListCondensed from "models/committee/CommitteeMinutePrintListCondensed";
import { useGetCommitteeMinute } from "models/committee/apiCommitteeMinute";
import { useHotkeys } from "react-hotkeys-hook";
import { useParams } from "react-router-dom";

const CommitteeMinute = ({}) => {
  const { committee_minute_id } = useParams();
  const theme = useTheme();
  const {
    data: committeeMinute,
    isSuccess: committeeMinuteIsSuccess,
    isError: committeeMinuteIsError,
  } = useGetCommitteeMinute(committee_minute_id);

  useHotkeys(
    "meta+p",
    () => {
      window.open(`/committee_minute/${committeeMinute.id}/print`, "_blank");
    },
    { preventDefault: true },
  );

  if (committeeMinuteIsError) {
    return <>Error</>;
  }

  if (!committeeMinuteIsSuccess) {
    return <Skeleton variant="rectangular" height={150} />;
  }

  return (
    <Layout container hideBreadcrumbs>
      <Layout title variant="component">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={1}
          width={1}
        >
          <Highlight color={theme.palette_custom.yellow}>
            {committeeMinute.name}
          </Highlight>
          <TopRightMenu style={{ marginLeft: "auto" }}>
            <TopRightMenuItem
              alwaysShow
              onClick={() =>
                window.open(
                  `/committee_minute/${committeeMinute.id}/print`,
                  "_blank",
                )
              }
              endIcon={<PrintSharpIcon sx={{ scale: "0.8" }} />}
              title="&#8984;+p"
            >
              Print
            </TopRightMenuItem>
          </TopRightMenu>
        </Stack>
      </Layout>
      <Layout content>
        <Typography textAlign="center" variant="h6">
          Investment committee
        </Typography>
        <Typography textAlign="center" variant="subtitle2">
          {committeeMinute.deal_flow.name}
        </Typography>
        <Typography textAlign="center" variant="body2">
          {dayjs(committeeMinute.created_at).format("DD-MM-YYYY HH:mm")}
        </Typography>

        <CommitteeMinutePrintListCondensed
          committeeMinuteId={committeeMinute.id}
        />
        <PVSignatures
          signatures={committeeMinute.deal_flow.signatures_detail}
        />
      </Layout>
    </Layout>
  );
};

export default CommitteeMinute;
